import {
  Link,
  useLocation,
  useNavigate,
  useParams,
  useSearchParams,
} from "react-router-dom";
import image1 from "../../assets/image1modipm.png";
import CategoryPolls from "../../components/CategoryPolls/CategoryPolls";
import { FaSearch } from "react-icons/fa";
import rightarrow from "../../assets/icons/Path 23098.svg";
import leftarrow from "../../assets/icons/Path 23107.svg";
import UsePollPredictionComp from "../../components/UsePollPredictionComp/UsePollPredictionComp";
import VoteShare from "../../components/VoteShare/VoteShare";
import PollingChart from "../../components/PollingChart/PollingChart";
import PollingTable from "../../components/PollingTable/PollingTable";
import SecHead from "../../components/SectionHeader/SecHead";
import { useEffect, useMemo, useState } from "react";
import usFlag from "../../assets/flag (2).png";
import { formatBreadcrumbName } from "../../helpers/utilities";
import { useDispatch, useSelector } from "react-redux";
import { getPollsYears, getStateCountry } from "../../redux/actions/pollingAction";

function Polling() {
const location = useLocation();
const heading = location?.pathname?.split("/")?.[2];
const slug1 = location?.pathname?.split("/")?.[1];

const { delhiPollsYearsResponse, stateCountry } = useSelector((state) => state.pollWeb);
console.log("🚀 ~ Polling ~ stateCountry:", stateCountry?.country_id)

let { slug } = useParams();
const dispatch = useDispatch();
const isVerified = localStorage.getItem("accessToken");
const navigate = useNavigate();
const [selectedYear, setSelectedYear] = useState("");
const [searchParams] = useSearchParams();
const type = searchParams.get("type");

// Memoize pollPayload to prevent unnecessary recalculations
const pollPayload = useMemo(() => {
  return type
    ? { country: localStorage.getItem("country") }
    : {
        country: localStorage.getItem("country"),
        state: localStorage.getItem("state"),
      };
}, [type]);

// First, get the state/country data
const statecountry = useMemo(() => {
return type
? { country: slug1 == "us-poll" ? "us-polls" : slug1 }
: {
    country: slug1 == "us-poll" ? "us-polls" : slug1,
state: heading
  };
}, [type]);
useEffect(() => {
  dispatch(getStateCountry(statecountry));
}, [dispatch, slug1, heading]);

// Then, when stateCountry is available, get the poll years
useEffect(() => {
  if (stateCountry) {
     localStorage.setItem("country", stateCountry.country_id);
    localStorage.setItem("state", stateCountry.state_id);
    dispatch(getPollsYears(pollPayload));
  }
}, [dispatch, stateCountry, pollPayload]);

// Finally, when we have the poll years response, set the selected year
useEffect(() => {
  if (delhiPollsYearsResponse?.length > 0) {
   
    setSelectedYear(delhiPollsYearsResponse[0]?.year);
  }
}, [delhiPollsYearsResponse, stateCountry]);

const params = `year=${selectedYear}`;
  // const stories = [
  //   {
  //     id: 1,
  //     image: image1,
  //     title: "Lok Sabha Election 2024 Major Takeaways1",
  //     categories: "India Polls",
  //     content:
  //       "The results of 2024 Lok Sabha have come as a disappointment for the ruling BJP who were highly excited after the exit polls.",
  //     date: "June 11, 2024",
  //   },
  //   {
  //     id: 2,
  //     image: image1,
  //     title: "Lok Sabha Election 2024 Major Takeaways2",
  //     categories: "India Polls",
  //     content:
  //       "The results of 2024 Lok Sabha have come as a disappointment for the ruling BJP who were highly excited after the exit polls.",
  //     date: "June 11, 2024",
  //   },
  //   {
  //     id: 3,
  //     image: image1,
  //     title: "Lok Sabha Election 2024 Major Takeaways3",
  //     categories: "India Polls",
  //     content:
  //       "The results of 2024 Lok Sabha have come as a disappointment for the ruling BJP who were highly excited after the exit polls.",
  //     date: "June 11, 2024",
  //   },
  //   {
  //     id: 4,
  //     image: image1,
  //     title: "Lok Sabha Election 2024 Major Takeaways3",
  //     categories: "India Polls",
  //     content:
  //       "The results of 2024 Lok Sabha have come as a disappointment for the ruling BJP who were highly excited after the exit polls.",
  //     date: "June 11, 2024",
  //   },
  //   {
  //     id: 5,
  //     image: image1,
  //     title: "Lok Sabha Election 2024 Major Takeaways3",
  //     categories: "India Polls",
  //     content:
  //       "The results of 2024 Lok Sabha have come as a disappointment for the ruling BJP who were highly excited after the exit polls.",
  //     date: "June 11, 2024",
  //   },
  //   {
  //     id: 5,
  //     image: image1,
  //     title: "Lok Sabha Election 2024 Major Takeaways3",
  //     categories: "India Polls",
  //     content:
  //       "The results of 2024 Lok Sabha have come as a disappointment for the ruling BJP who were highly excited after the exit polls.",
  //     date: "June 11, 2024",
  //   },
  // ];

  // const posts = [
  //   {
  //     id: 1,
  //     image: image1,
  //     category: "India Polls",
  //     title: "PM-Kisan Samman Nidhi Yojana: Voter Coverage",
  //     date: "June 11, 2024",
  //   },
  //   {
  //     id: 2,
  //     image: image1,
  //     category: "India Polls",
  //     title: "PM-Kisan Samman Nidhi Yojana: Voter Coverage",
  //     date: "June 11, 2024",
  //   },
  //   {
  //     id: 3,
  //     image: image1,
  //     category: "India Polls",
  //     title: "PM-Kisan Samman Nidhi Yojana: Voter Coverage",
  //     date: "June 11, 2024",
  //   },
  // ];

  const [voteType, setVoteType] = useState("popular-polls");

  const date = new Date("2024-08-12T14:55:00");
  const options = {
    month: "short",
    day: "2-digit",
    year: "numeric",
    hour: "numeric",
    minute: "numeric",
    hour12: true,
  };

  const formattedDate =
    date.toLocaleString("en-US", options).toUpperCase().replace(",", "") +
    " AT " +
    date
      .toLocaleString("en-US", {
        hour: "numeric",
        minute: "numeric",
        hour12: true,
      })
      .toUpperCase();

  return (
    <>
      <div className="bg_home flex flex-col pb-8">
        <div className="flex flex-row px-6 md:px-40 gap-4 text-[12px] font-semibold bg-[#E2E7EE]">
          <Link
            to={`/us-polls/general-stories`}
            className={` py-2 ${location.pathname === `/us-polls/general-stories`
                ? "font-bold current-page"
                : "text-[#7F8FA4]"
              }`}
          >
            General Stories
          </Link>
          <Link
            to={`/us-polls/polling`}
            className={`  py-2 mx-2 ${location.pathname === "/us-polls/polling" ||
                location.pathname === `/us-polls/${slug}`
                ? "font-bold current-page"
                : "text-[#7F8FA4]"
              }`}
          >
            Polls
          </Link>

          <Link
            to={`/us-polls/predictions_post`}
            className={` py-2 ${"text-[#7F8FA4]"}`}
          >
            Predictions
          </Link>
        </div>
        <div className="bg_home md:bg-[#F7F8FA] px-4  md:px-40 flex flex-col pb-6 md:py-5">
          <div className="bg-white w-full rounded-xl shadow-sm p-3 md:p-5   md:block">
            <div className=" h-auto pb-14 ">
              <div className="flex flex-col flex-wrap gap-1">
                <div className="flex flex-row flex-wrap justify-between items-center">
                  <div className="text-[16px]">
                    <CategoryPolls
                      title={formatBreadcrumbName(heading)}
                      img={usFlag}
                    />
                  </div>
                  <div className="flex flex-wrap wrap gap-2">
                    <div className="flex items-center gap-2">
                      <span className="text-[14px]">Select Year:</span>
                      <select
                        className="bg-[#E2E7EE] rounded-full px-4 py-1 text-[12px] "
                        value={selectedYear}
                        onChange={(e) => setSelectedYear(e.target.value)}
                      >
                        {delhiPollsYearsResponse?.map((yearObj) => (
                          <option key={yearObj.id} value={yearObj.year}>
                            {yearObj.year}
                          </option>
                        ))}
                      </select>
                    </div>
                    <div className="flex flex-row items-center gap-2">
                      <div className="text-center text-[12px]">POLL TYPE</div>
                      <select
                        className="bg-[#E2E7EE] rounded-xl px-2 py-1 text-[12px]"
                        onChange={(e) => setVoteType(e.target.value)}
                      >
                        <option
                          className="text-[#000] px-2"
                          value="popular-polls"
                        >
                          Popular Votes
                        </option>
                        <option
                          className="text-[#000] px-2"
                          value="electoral-votes"
                        >
                          Electoral Votes
                        </option>
                      </select>
                    </div>
                  </div>
                </div>
              </div>
              <UsePollPredictionComp type={voteType} selectedYear={selectedYear} />
            </div>
            <div className=" h-auto mt-10">
              <div className="flex flex-row justify-between items-center">
                <div className="text-[16px]">Polling Chart</div>

              </div>

              {/* polling chart start */}
              <PollingChart selectedYear={selectedYear} />

              {/* polling chart end */}
              <div className="flex flex-col gap-3">
                <div className="text-[16px]">Polling Table</div>

                <PollingTable selectedYear={selectedYear} />
              </div>
              {/* <div className="py-6">
                <div className="text-[12px] text-gray-700 font-semibold ">
                  Summary
                </div>
                <p className="text-[12px] text-gray-500 py-2 leading-5 text-justify">
                  The race between Joe Biden and Donald Trump is very close.
                  Over the first three months of 2024 the candidates were never
                  more than three points apart in our average of national polls,
                  with Mr Trump narrowly ahead for most of that time. That is
                  new for Mr Trump: in his two previous presidential campaigns
                  he never led a general-election polling average for a single
                  day. More worrying still for Mr Biden, Mr Trump is ahead in
                  several of the swing states that he lost in 2020. The outcome
                  in half a dozen states— Arizona, Georgia, Michigan, Nevada,
                  Pennsylvania and Wisconsin—is likely to prove decisive. A
                  small but critical slice of voters who plumped for Mr Biden
                  back then are now telling pollsters that they plan to defect.
                  Who are they? To find out, we built a statistical model to
                  assess how a hypothetical voter might cast a ballot, based on
                  their demographic traits. Our data come from YouGov, an online
                  pollster, which every week surveys over a thousand people
                  about their demographic profile, voting history and voting
                  intentions. We combined all its survey results since January
                  2023 to get a detailed portrait of Americans’ voting
                  preferences. Use the drop-down menus below to plug in any
                  combination of attributes—age, sex, religion and more—to
                  construct a hypothetical American and see our estimate of
                  their vote. Or press shuffle to see a voter at random. Our
                  model will continuously update to incorporate each week’s
                  YouGov survey.
                </p>
              </div> */}
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
export default Polling;
